// LocationScreen.tsx
import { useEffect, useState, useMemo, useCallback } from 'react'
import { Breadcrumb, Button, Card, Col, Divider, Input, Pagination, Row, Select, Table, Typography } from 'antd'
import {
   HomeOutlined,
   PlusCircleOutlined,
   InfoCircleOutlined,
   EditOutlined,
   DeleteOutlined,
   ExclamationCircleOutlined,
   SearchOutlined
} from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { ROUTER_PATH } from '../routes/metaData'
import useModal from 'src/helpers/modal/useModal'
import { formatCurrency } from 'src/helpers/functions'
import {
   convertPageToOffset,
   DATE_TIME_FORMAT_BACKEND,
   DATE_TIME_FORMAT_CLIENT,
   getPage,
   PAGE_SIZE,
   TYPE_PROMOTION_CODE
} from 'src/helpers/constants'
import { isEmpty, size, trim } from 'lodash'
import { useLoading } from 'src/common/components/LoadingContainer'
import { useStore } from 'src/hooks'
import moment from 'moment'
const { Title } = Typography

const LocationScreen = observer(() => {
   const history = useHistory()
   const { t } = useTranslation()
   const { confirm } = useModal()
   const UserStore = useStore('UserStore')
   const { rows, offset, count } = UserStore.listNotifications
   const [textSearch, set_textSearch] = useState('')
   const { showLoading, hideLoading } = useLoading()
   const [fieldFilter, setFieldFilter] = useState<any>({})

   useEffect(() => {
      getListNotification()
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   const getListNotification = async () => {
      await UserStore.getNotifications('1', {})
   }

   useEffect(() => {
      if (size(trim(textSearch)) > 0) {
         getListData(1, { ...fieldFilter, ...{ keyword: trim(textSearch) } })
      } else {
         getListData(1, { ...fieldFilter })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [textSearch, fieldFilter])

   const getListData = async (currentPage: number, param?: any) => {
      try {
         showLoading()
         // const page = currentPage
         const params = { limit: PAGE_SIZE, page: currentPage, ...param }

         await UserStore.getNotifications('1', params)
      } catch (error) {
         // console.log(error)
      } finally {
         hideLoading()
      }
   }

   const onChange = (currentPage: number) => {
      if (size(trim(textSearch)) > 0) {
         getListData(currentPage, { ...fieldFilter, ...{ keyword: trim(textSearch) } })
      } else {
         getListData(currentPage, { ...fieldFilter })
      }
   }

   const handleChangeTextSearch = (value: any) => {
      set_textSearch(value)
   }
   const handleRedirectToCreate = useCallback(() => {
      history.push(`/${ROUTER_PATH.NotificationCreateScreen}`)
   }, [history])

   const columns = useMemo(
      () => [
         { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
         {
            title: 'Tiêu đề',
            dataIndex: 'title',
            key: 'title'
         },
         { title: 'Nội dung', dataIndex: 'message', key: 'message' },
         { title: 'Nhóm', dataIndex: 'note', key: 'note' },
         {
            title: 'Ngày tạo',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (val: any) => moment(val).format(DATE_TIME_FORMAT_CLIENT)
         }
      ],
      []
   )

   const renderPagination = () => {
      if (isEmpty(rows)) {
         return null
      }

      return (
         <div className="containerPagination">
            <Pagination
               onChange={onChange}
               pageSize={PAGE_SIZE}
               current={offset / PAGE_SIZE + 1}
               showSizeChanger={false}
               total={count}
            />
         </div>
      )
   }

   return (
      <div>
         <Row style={{ padding: '0 20px' }} className="gx-justify-content-between gx-align-items-center">
            <Col>
               <Title level={4}>{'Thông báo'}</Title>
               <Breadcrumb>
                  <Breadcrumb.Item href="/">
                     <HomeOutlined className="gx-link" />
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>{'Admin'}</Breadcrumb.Item>
                  <Breadcrumb.Item className="gx-link">{'Thông báo'}</Breadcrumb.Item>
               </Breadcrumb>
            </Col>
            <Col>
               <Button icon={<PlusCircleOutlined />} type="primary" onClick={handleRedirectToCreate}>
                  {t('add_new')}
               </Button>
            </Col>
         </Row>

         <Card style={{ marginTop: '20px' }}>
            <Row gutter={16}>
               <Col span={8}>
                  <Input.Search placeholder={t('search')} allowClear onSearch={handleChangeTextSearch} />
               </Col>

               {/* <Col span={4}>
                  <Button icon={<SearchOutlined />} type="primary">
                     {t('search')}
                  </Button>
               </Col> */}
            </Row>

            <Table style={{ marginTop: 20 }} columns={columns} dataSource={rows || []} rowKey="id" pagination={false} />
            {renderPagination()}
         </Card>
      </div>
   )
})

export default LocationScreen
